<template>
    <section
        class="testimonial section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="testimonial-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content invert-color" />
                <div
                    class="tiles-wrap illustration-section-06"
                    :class="[
                        pushLeft && 'push-left',
                    ]">
                    <div class="tiles-item reveal-scale-up">
                        <div class="tiles-item-inner has-shadow">
                            <div class="testimonial-item-header">
                                <div class="testimonial-item-image">
                                    <c-image
                                        :src="require('@/assets/images/testimonial-image-01.png')"
                                        alt="Testimonial image 01"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="testimonial-item-content">
                                <p class="text-sm mb-0" align="justify" >
                                    Easy to get in and out to pick up ordered goods , unlike other places that keep you waiting for long periods of time and can't find your goods readily!!
                                </p>
                            </div>
                            <div class="testimonial-item-footer h6 mt-32 mb-0 pt-24 has-top-divider">
                                <span class="testimonial-item-name">
                                    Boogie26 Robert
                                </span>
                                <span class="text-color-low"> - </span>
                                <span class="testimonial-item-link text-xs">
                                    <a href="#">Google review</a>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-up" data-reveal-delay="200">
                        <div class="tiles-item-inner has-shadow">
                            <div class="testimonial-item-header">
                                <div class="testimonial-item-image">
                                    <c-image
                                        :src="require('@/assets/images/testimonial-image-02.png')"
                                        alt="Testimonial image 02"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="testimonial-item-content">
                                <p class="text-sm mb-0" align="justify">
                                    Friendly staff and great services, best thing is they are open in weekends!
                                </p>
                            </div>
                            <div
                                class="testimonial-item-footer h6 mt-32 mb-0 pt-24 has-top-divider">
                                <span class="testimonial-item-name">
                                    Zheng Hong
                                </span>
                                <span class="text-color-low"> - </span>
                                <span class="testimonial-item-link text-xs">
                                    <a href="#">Google review</a>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-up" data-reveal-delay="400">
                        <div class="tiles-item-inner has-shadow">
                            <div class="testimonial-item-header">
                                <div class="testimonial-item-image">
                                    <c-image
                                        :src="require('@/assets/images/testimonial-image-03.png')"
                                        alt="Testimonial image 03"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="testimonial-item-content">
                                <p class="text-sm mb-0" align="justify">
                                    Great courier service to send items to China from Perth, the wife and I regularly use Line 1 to send gifts to family
                                </p>
                            </div>
                            <div
                                class="testimonial-item-footer h6 mt-32 mb-0 pt-24 has-top-divider">
                                <span class="testimonial-item-name">
                                   Troy Walters
                                </span>
                                <span class="text-color-low"> - </span>
                                <span class="testimonial-item-link text-xs">
                                    <a href="#">Google review</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CImage from '@/components/elements/Image.vue'

export default {
  name: 'CTestimonial',
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: 'Testimonials',
        paragraph: ''
      }
    }
  }
}
</script>